import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_ORDER_ACTUAL_HRS } from "../queries/GetOrderDetails";

//Get actual hours on a order
const fetchOrderActualHrs = async ({ queryKey }) => {
    const [, { token, orderDetailId }] = queryKey;

    if (!token) throw new Error("Token not available");

    try {
        const response = await axios.get(`/getOrderAssignation/${orderDetailId}`, {
            headers: {
              Authorization: token,
            },
          });
        return response.data;

    } catch (error) {
        throw new Error(error.response?.data || "Error fetching data");
    }
};

export const useGetOrderActualHrs = (params) => {
    return useQuery({
        queryKey: [GET_ORDER_ACTUAL_HRS, params],
        queryFn: fetchOrderActualHrs,
        enabled: !!params.token,
        retry: false,
    });
};